/* istanbul ignore file */
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from "react-router-dom";
import App from './components/App';
import { store } from './configureStore';
import {SessionTimeoutProvider} from "./components/session/SessionTimeoutProvider";

render(
  <Provider store={store}>
    <SessionTimeoutProvider>
      <Router>
        <App />
      </Router>
    </SessionTimeoutProvider>
  </Provider>,
  document.getElementById('root')
)